const template = `
  <label class="toggle" style="font-size: {{fontSize}}px">
    <input type="checkbox" ng-model="model" ng-click="onToggle()" />
    <span data-on="{{onText}}" data-off="{{offText}}"></span>
  </label>
`;

class ToggleDirective {
  /* @ngInject */
  constructor() {
    Object.assign(this, {
      template,
      restrict: 'E',
      require: 'ngModel',
      scope: {
        model: '=ngModel',
        fontSize: '=',
        onToggle: '&'
      }
    });
  }

  link(scope, element, attrs) {
    scope.onText = attrs.onText || 'On';
    scope.offText = attrs.offText || 'Off';
  }

}

ToggleDirective.$inject = [];
angular.module('pims').directive('toggle', () => new ToggleDirective());